import React, {useEffect} from 'react';

export default function ScrollDown() {
    return (
        <div id="section01" class="demo">
            <h1>Scroll Down Button #1</h1>
            <a href="#section02"><span></span>Scroll</a>
        </div>
    )
}